import { useState } from "react";
import { log } from "../../lib/log";
import { LINE_ORDER } from "./constants";

const STORAGE_KEY = "stargrid.visibleLines";

// Per-line visibility (all ON by default), persisted to localStorage across scans/reloads.
export function useVisibleLines() {
  const [visibleLines, setVisibleLines] = useState(() => {
    const initial = LINE_ORDER.reduce((acc, k) => ({ ...acc, [k]: true }), {});
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
      if (saved && typeof saved === "object") return { ...initial, ...saved };
    } catch (e) {
      log.warn("WorldMap: could not read saved line filters:", e);
    }
    return initial;
  });
  const toggleLine = (planet) => setVisibleLines((v) => {
    const next = { ...v, [planet]: !v[planet] };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch (e) { log.warn("WorldMap: could not persist line filters:", e); }
    return next;
  });
  return [visibleLines, toggleLine];
}
